module.exports = __webpack_public_path__ + "img/kr-product-card3-item4-step1.f48c6e8.png";